import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { CheckCircleOutlined, CloseCircleOutlined, FileTextOutlined, ArrowRightOutlined } from '@ant-design/icons';
import s from '../../s.module.less';

interface IResultNodeData {
    label?: string;
    type: 'result';
    resultType?: 'not_suitable' | 'text_visit' | 'continue' | 'add_note';
    skipToQuestionId?: string;
    selectedOptions?: string[];
    customText?: string;
}

const ResultNode: React.FC<NodeProps<IResultNodeData>> = ({ data, selected }) => {
    const getResultIcon = (resultType?: string) => {
        switch (resultType) {
            case 'not_suitable':
                return <CloseCircleOutlined />;
            case 'text_visit':
                return <FileTextOutlined />;
            case 'continue':
                return <ArrowRightOutlined />;
            case 'add_note':
                return <FileTextOutlined />;
            default:
                return <CheckCircleOutlined />;
        }
    };

    const getResultLabel = (resultType?: string) => {
        switch (resultType) {
            case 'not_suitable':
                return 'Not Suitable';
            case 'text_visit':
                return 'Text Visit';
            case 'continue':
                return 'Continue';
            case 'add_note':
                return 'Add Note';
            default:
                return data.label || 'Result';
        }
    };

    return (
        <div className={`${s.resultNode} ${selected ? 'selected' : ''}`}>
            <Handle
                type="target"
                position={Position.Left}
                id="left"
                style={{ background: '#fa8c16' }}
            />
            <div className={s.nodeContent}>
                <div className={s.nodeIcon}>
                    {getResultIcon(data.resultType)}
                </div>
                <div className={s.nodeLabel}>
                    {getResultLabel(data.resultType)}
                </div>
                {data.skipToQuestionId && (
                    <div className={s.nodeSubLabel}>
                        Skip to: {data.skipToQuestionId}
                    </div>
                )}
                {data.selectedOptions && data.selectedOptions.length > 0 && (
                    <div className={s.nodeSubLabel}>
                        Options: {data.selectedOptions.join(', ')}
                    </div>
                )}
                {data.customText && (
                    <div className={s.nodeSubLabel}>
                        {data.customText}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResultNode;
